import React from "react";
import { connect } from 'react-redux'

import { client } from '../../services/client';
import Menu from '../utils/menu/Menu';

class Leaderboard extends React.Component {
    state = {
        leaderboardEntries: [],
        organisations: []
    }

    async componentDidMount() {
        const leaderboardEntries = await client.service('leaderboard').find(
            {
                paginate: false,
                query: {
                    isCompiled:  true, $sort: {score: -1}
                }
            }
        )

        const organisationIds = leaderboardEntries.map(entry => (entry.organisationId));

        const organisations = await client.service('organisations').find({ paginate: false, query: { _id: {$in: organisationIds}} })

        this.setState({
            leaderboardEntries,
            organisations
        })

        console.log('leaderboardEntries: ', leaderboardEntries)
    }

    render() {
        const entries = this.state.leaderboardEntries.map(leaderboardEntry => {
            const organisation = this.state.organisations.find(org => (org._id === leaderboardEntry.organisationId));

            return {
                shortcut: leaderboardEntry.score,
                text: organisation.name
            }
        })

        return (
            <div className="leaderboard">
            	<Menu options={entries}/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    
    // 

    return {
        
    }
}

export default connect(
    mapStateToProps,
    {
        
    }
)(Leaderboard);